export const useGoogleDataLayers = (map: Ref<google.maps.Map | undefined>, settings: Ref<OrganizationSettings | undefined>) => {
  const mapFeatures = ref<Array<MapFeatureData>>([])

  const geoLayers = ref<Array<SamMapLayer>>([])
  const geoLayersDuoPP = ref<Array<SamMapLayer>>([])

  watch(
    () => [settings.value, !!map.value],
    async () => {
      if (!settings.value || !map.value) {
        return
      }

      if (settings.value.geoLayers) {
        const defaultGeoLayers = [
          "BeheerGebied",
          "BeheerPut",
          "BeheerLeiding",
          "BeheerPomp",
          "BeheerLozing",
          "BeheerBouwwerk",
          "AansluitingLeiding",
          "AansluitingPunt",
        ]
        geoLayers.value = await Promise.all(defaultGeoLayers.map((layer, index) => useMapLayerForGoogleMaps(map, index, layer)))
      }
      if (settings.value.geoLayersDuoPP) {
        geoLayersDuoPP.value = await Promise.all(
          settings.value.geoDuoPPCategories
            .filter((mapCategory) => mapCategory.enabled)
            .map((mapCategory, index) =>
              useMapLayerForGoogleMaps(map, index, mapCategory.key, settings.value?.geoLayersDuoPPOrganizationName),
            ),
        )
      }
    },
    { deep: true, immediate: true },
  )

  const initializeLayers = () => {
    map.value?.addListener("click", async (e: { latLng: google.maps.LatLng }) => {
      if (!map.value) {
        return
      }

      const activeLayers = map.value?.overlayMapTypes
        .getArray()
        .map((mapType) => mapType?.name)
        .filter((name): name is string => !!name)

      const scaleFactor = Math.pow(2, map.value.getZoom() || 0)
      const latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() }

      mapFeatures.value = await getLayerFeatures(scaleFactor, latLng, activeLayers)
    })
  }

  return {
    initializeLayers,
    geoLayers,
    geoLayersDuoPP,
    mapFeatures,
  }
}
